export const RESOLUTION_SELECT_PLACEHOLDER = "Resolutions";

export const RESOLUTION_SELECT_OPTION_TEST_ID = "all-resolution-item";
